import { yupResolver } from "@hookform/resolvers/yup";
import { PencilSimple, Trash } from "phosphor-react";
import { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import * as yup from "yup";
import ActionButton from "../../../components/ActionButton";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import ItemsList, { HeaderList, ListItem } from "../../../components/ItemsList";
import ModalAction from "../../../components/ModalAction";
import PageTitle from "../../../components/PageTitle";
import TabSwitcher from "../../../components/TabSwitcher";
import Template from "../../../components/Template";
import { adicionarRiscoSubtitulo, alterarRiscoSubtitulo, excluirRiscoSubtitulo, obterListaRiscoSubtitulo } from '../../../services/api/Configuracoes/RiscoSubtitulo/index';
import { IAlterarRiscoSubtitulo, IObterListaRiscoSubtituloResponse } from '../../../services/models/Configuracoes/RiscoSubtitulo/index';
import * as S from "../style";
import { usePermissionsStore } from "../../../stores/PermissionsStore";

const AddRiskSubtitleSchema = yup.object({
    descricao: yup.string().required("O nome é obrigatório.")
})

interface item extends IObterListaRiscoSubtituloResponse { }

const RiskSubtitle = () => {
    const [view, setView] = useState<number>(0)
    const [RiskSubtitleList, setRiskSubtitleList] = useState<any>(null)

    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
    const [showEditModal, setShowEditModal] = useState<boolean>(false)
    const [itemToDelete, setItemToDelete] = useState<item | null>(null)
    const [itemToEdit, setItemToEdit] = useState<item | null>(null)

    useEffect(() => {
        view === 0 && ObterListaRiscoSubtitulo()
    }, [view])

    const {
        handleSubmit,
        control,
        reset,
        formState: {
            errors,
            isValid
        }
    } = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        resolver: yupResolver(AddRiskSubtitleSchema)
    })

    const ObterListaRiscoSubtitulo = async () => {
        let res = await obterListaRiscoSubtitulo()
        setRiskSubtitleList(res)
    }

    const AdicionarRiscoSubtitulo = async (data: any) => {
        let body = {
            ...data
        }

        await adicionarRiscoSubtitulo(body).then(() => {
            reset({
                descricao: null
            })
        })
    }

    const ExcluirRiscoSubtitulo = async (idRiscoSubtitulo: number) => {
        await excluirRiscoSubtitulo({ idRiscoSubtitulo })
        ObterListaRiscoSubtitulo()
    }

    const EditarRiscoSubtitulo = async (newRiscoSubtitulo: IAlterarRiscoSubtitulo) => {
        await alterarRiscoSubtitulo(newRiscoSubtitulo)
        ObterListaRiscoSubtitulo()
    }

    const handleShowDeleteModal = (item: item) => {
        setItemToDelete(item)
        setShowDeleteModal(true)
    }

    const handleShowEditModal = (item: item) => {
        setItemToEdit(item)
        setShowEditModal(true)
    }

    const findPermission = usePermissionsStore((state) => state.findPermission);

    const permissions = findPermission(7);

    // PARA TESTE
    // const permissions = {
    //     permiteInserir: false,
    //     permiteAlterar: false,
    //     permiteExcluir: false,
    // }

    const {
        permiteInserir,
        permiteAlterar,
        permiteExcluir
    } = permissions;

    const menuItems = permiteInserir ?
        [
            "Dados",
            "Adicionar"
        ] : [
            "Dados"
        ]

    const headerList = permiteAlterar || permiteExcluir ?
        [
            "Descrição",
            "Status",
            "Ações"
        ] : [
            "Descrição",
            "Status"
        ]

    return (
        <Template>
            <PageTitle>
                Risco Subtítulo
            </PageTitle>
            <TabSwitcher
                list={menuItems}
                view={view}
                setView={setView}
            />
            <S.Content>
                <S.ControlView active={view === 0}>
                    {
                        RiskSubtitleList ? (
                            <ItemsList>
                                <HeaderList items={headerList} />
                                {
                                    RiskSubtitleList.map((item: item, index: any) => {
                                        return (
                                            <ListItem key={index}>
                                                <div>{item.descricao}</div>
                                                <div>{item.isAtivo ? "Ativo" : "Inativo"}</div>
                                                {
                                                    (
                                                        permiteAlterar ||
                                                        permiteExcluir
                                                    ) && (
                                                        <div>
                                                            {
                                                                permiteAlterar && (
                                                                    <ActionButton act="edit" onClick={() => handleShowEditModal(item)}>
                                                                        <PencilSimple />
                                                                    </ActionButton>
                                                                )
                                                            }
                                                            {
                                                                permiteExcluir && (
                                                                    <ActionButton act="delete" onClick={() => handleShowDeleteModal(item)}>
                                                                        <Trash />
                                                                    </ActionButton>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </ListItem>
                                        )
                                    })
                                }
                            </ItemsList>
                        ) : (
                            <p>Carregando ...</p>
                        )
                    }
                </S.ControlView>
                <S.ControlView active={view === 1} id="addRisk" onSubmit={handleSubmit((data) => AdicionarRiscoSubtitulo(data))}>
                    <S.GridItem cols={2}>
                        <Input
                            id="descricao"
                            name="descricao"
                            label="Descrição"
                            control={control}
                            error={errors.descricao?.message}
                        />
                    </S.GridItem>
                    {
                        isValid && (
                            <S.GridItem cols={6}>
                                <Button type="submit" form="addRisk">Adicionar</Button>
                            </S.GridItem>
                        )
                    }
                </S.ControlView>
            </S.Content>
            {
                showDeleteModal && itemToDelete && (
                    <ModalAction
                        type="delete"
                        onConfirm={() => ExcluirRiscoSubtitulo(itemToDelete.id)}
                        onClose={() => setShowDeleteModal(false)}
                        title="Excluir Risco Subtítulo"
                        item={itemToDelete}
                    />
                )
            }
            {
                showEditModal && itemToEdit && (
                    <ModalAction
                        type="edit"
                        onConfirm={(e) => EditarRiscoSubtitulo(e)}
                        onClose={() => setShowEditModal(false)}
                        title="Editar Risco Subtítulo"
                        item={itemToEdit}
                    />
                )
            }
        </Template>
    )
}

export default RiskSubtitle